const allVouch = { data: [], loading: true };

export const GetAllRevertBackUserVouchers = (state = allVouch, action) => {
  switch (action.type) {
    case "get_revertbackUserVouch":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
